import { Search } from 'lucide-react';
import React from 'react';
import { FaSearch } from 'react-icons/fa';

const SearchInput = ({ placeholder, onChange }) => {
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '320px',
     color: '#666',
    height: '38px',
    padding: '8px 10px',
    gap: '10px',
    borderRadius: '4px',
  opacity: '0.9',
  background: '#F3F4F6',
  };

  const iconStyle = {
    fontSize: '18px',
    color: '#666',
  };

  const inputStyle = {
    width: '100%',
    border: 'none',
    background: 'transparent',
    outline: 'none',
    fontSize: '14px',
    color: '#333',
  };

  return (
    <div style={containerStyle}>
      <Search style={iconStyle} />
      <input
        type="text"
        style={inputStyle}
        placeholder={placeholder || 'Search'}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchInput;
